/**
 * Debug Configuration
 * 
 * Controls visibility of debug components throughout the application
 * Set DEBUG_ENABLED to false in production to hide all debug panels
 */

// Debug mode flag
// Change to false to hide all debug components in production
export const DEBUG_ENABLED = false;

/**
 * Debug component visibility settings
 * Each setting can be controlled independently
 */
export const DEBUG_CONFIG = {
  // Show State Debugger panels
  showStateDebugger: DEBUG_ENABLED && true,
  
  // Show Cart Payload Tester
  showCartPayloadTester: DEBUG_ENABLED && true,
  
  // Show raw JSON data in Step 4 ("Your Customization" section)
  showRawImprintData: DEBUG_ENABLED && true,
  
  // Show debug info in Review section (gray box with state data)
  showReviewDebugInfo: DEBUG_ENABLED && true,
  
  // Show "Customization Method" section in Review
  showCustomizationMethodInfo: DEBUG_ENABLED && true,
  
  // Show Step 3: Add-Ons section
  showAddOnsSection: DEBUG_ENABLED && true,
  
  // Show Special Instructions in Step 2 (Start New Imprint form)
  showSpecialInstructionsStep2: DEBUG_ENABLED && false,
  
  // Show "Components to migrate" section
  showMigrationInfo: DEBUG_ENABLED && false,
  
  // Show console logs from stores
  enableStoreLogging: DEBUG_ENABLED && true,
  
  // Show validation debug info
  showValidationDebug: DEBUG_ENABLED && false,
  
  // Show calendar single debug info (yellow box with product data)
  showCalendarSingleDebug: DEBUG_ENABLED && false,
};

/**
 * Helper function to check if debug mode is enabled
 * @returns {boolean}
 */
export function isDebugMode() {
  return DEBUG_ENABLED;
}

/**
 * Helper function to check specific debug feature
 * @param {string} feature - Feature name from DEBUG_CONFIG
 * @returns {boolean}
 */
export function isDebugFeatureEnabled(feature) {
  return DEBUG_CONFIG[feature] || false;
}

/**
 * Environment-based debug mode
 * Automatically disable debug in production builds
 */
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const AUTO_DEBUG = !IS_PRODUCTION && DEBUG_ENABLED;

/**
 * Quick toggle for all debug features
 * Use this in production: setDebugMode(false)
 */
export function setDebugMode(enabled) {
  Object.keys(DEBUG_CONFIG).forEach(key => {
    DEBUG_CONFIG[key] = enabled;
  });
}

// Export default config object
export default {
  DEBUG_ENABLED,
  DEBUG_CONFIG,
  isDebugMode,
  isDebugFeatureEnabled,
  IS_PRODUCTION,
  AUTO_DEBUG,
  setDebugMode
};
